import { ImageCart } from "@/Components/Images/ImagesCart/ImageCart";
import {
  GridSalePricev2,
  LayoutCarousel,
  StarRating,
} from "@/Components/Index";
import useWindowsSize from "@/Hooks/useWindowsSize";
import { useViewInfoProduct } from "@/Service/Api/Index";
import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

type propsModal = {
  viewModal: boolean;
  setViewModal: (VModals: boolean) => void;
  //   //datos.
  //Products?: products[];
  //   //
  id?: string;
  category?: string;
  subcategory?: string;
  heanddleAddCart?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  viewButton?: boolean;
};

// const propsStyles = {
//   // width: "750px",
//   // margin: "0 -100px",
// };

const ModalViewData = ({
  viewModal,
  setViewModal,
  //Products,
  id,
  category,
  subcategory,
  heanddleAddCart,
  viewButton = true,
}: propsModal) => {
  const { width } = useWindowsSize();
  const { mDatos: ProductosView, isLoading } = useViewInfoProduct(
    id!,
    category!,
    subcategory!
  );

  // const Productos = Products?.filter((w) => w.Id === id)?.map(
  //   (item) => item
  // )[0];
  const Productos = ProductosView?.map((item) => item)[0];
  ///-> datos.
  let listPriceP = Productos?.ListPriceBasket ?? 0;
  let salePriceP = Productos?.SalesPriceBasket ?? 0;
  const sourceImageV2 = Productos?.ImageZoomGroups?.map((x) => {
    const allLinks = x?.images?.flatMap((t) => t.link);
    return allLinks;
  })[0];

  const [contImage, setContImage] = useState<number>(0);

  const headdleNext = () => {
    const totalImg = sourceImageV2?.length;
    const maxIndex = Math.min(contImage + 1, Number(totalImg) - 1);
    setContImage(maxIndex);
  };

  const headdlePrev = () => {
    const newIndex = Math.max(contImage - 1, 0);
    setContImage(newIndex);
  };

  return (
    <div
      className={`modal fade ${viewModal ? "show d-block" : ""}`}
      tabIndex={-1}
      role="dialog"
      style={viewModal ? { backgroundColor: "rgba(0,0,0,0.5)" } : {}}>
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        role="document">
        <div
          className="modal-content bg-white"
          //style={width > 998 ? propsStyles : {}}
        >
          <div className="modal-header">
            <span className="modal-close" data-bs-dismiss="modal">
              <i
                className="icon-cross2 text-dark"
                onClick={() => setViewModal(false)}></i>
            </span>
          </div>
          <div className="modal-body w-100">
            <div className="row">
              {width > 766 && (
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-12">
                  <div className="row">
                    <div className="col-1">
                      <div className="d-flex justify-content-center align-items-center h-100">
                        {!isLoading ? (
                          <Link
                            to={"#"}
                            className="slick-arrow slick-disabled"
                            aria-disabled="false"
                            style={{}}
                            onClick={headdlePrev}>
                            <i
                              className="fa fa-angle-left text-danger"
                              style={{ fontSize: 32 }}></i>
                          </Link>
                        ) : (
                          <Skeleton width={"5rem"} height={"5rem"} />
                        )}
                      </div>
                    </div>
                    <div className="col-10">
                      <div
                        className="ps-product__thumbnail"
                        data-vertical="false">
                        <div className="ps-wrapper">
                          <div
                            className="ps-product__gallery"
                            data-arrow="true">
                            <LayoutCarousel
                              sildesPerView={1}
                              sildesPerViewTwo={1}
                              reference={contImage}>
                              {!isLoading ? (
                                sourceImageV2?.map((img, index) => (
                                  <div
                                    className="item w-50 mx-auto"
                                    key={index}>
                                    <Link to={""}>
                                      <ImageCart
                                        srcx={img ?? ""}
                                        altx={`slide-${index}`}
                                        srcDefault={Productos?.Default ?? ""}
                                      />
                                    </Link>
                                  </div>
                                ))
                              ) : (
                                <Skeleton height={"250px"} />
                              )}
                            </LayoutCarousel>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-1">
                      <div className="d-flex justify-content-center align-items-center h-100">
                        {!isLoading ? (
                          <Link
                            to={""}
                            className="slick-arrow slick-disabled"
                            style={{}}
                            aria-disabled="true"
                            onClick={headdleNext}>
                            <i
                              className="fa fa-angle-right text-danger"
                              style={{ fontSize: 32 }}></i>
                          </Link>
                        ) : (
                          <Skeleton width={"5rem"} height={"5rem"} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="ps-product--detail ">
                  <div className="ps-product__info">
                    <h1>
                      {!isLoading ? (
                        Productos?.Name
                      ) : (
                        <Skeleton height={"10rem"} />
                      )}
                    </h1>
                    <div className="ps-product__meta">
                      {!isLoading && (
                        <>
                          <p className="p-1">
                            Marca : <strong>{Productos?.Brand}</strong>
                          </p>
                          <div className="ps-product__rating">
                            <div className="br-wrapper br-theme-fontawesome-stars">
                              <div className="br-widget br-readonly">
                                <StarRating
                                  rating={Math.floor(
                                    Number(Productos?.CBvAverageRating) > 0
                                      ? Number(Productos?.CBvAverageRating)
                                      : 2
                                  )}
                                  totales={
                                    Number(Productos?.CBvRatingRange) > 0
                                      ? Number(Productos?.CBvRatingRange)
                                      : 5
                                  }
                                  fontStar={16}
                                  fontNumber={16}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    <h4 className="ps-product__price">
                      {!isLoading ? (
                        width > 766 ? (
                          (salePriceP ?? 0) < (listPriceP ?? 0) ? (
                            <>
                              <span className="develop___Color_SalePrice__red">
                                ${salePriceP}{" "}
                              </span>
                              -
                              <span className="develop___subrayado">
                                {" "}
                                ${listPriceP}
                              </span>
                            </>
                          ) : (
                            <span className="develop___salePrice develop___Color_SalePrice__dark">
                              ${salePriceP}
                            </span>
                          )
                        ) : (
                          <GridSalePricev2
                            listPrice={listPriceP}
                            salesPrice={salePriceP}
                            isLoading={isLoading}
                          />
                        )
                      ) : (
                        <Skeleton height={"5rem"} />
                      )}
                    </h4>
                    <div className="ps-product__desc">
                      {!isLoading ? (
                        <>
                          <p>
                            <Link
                              to={`/Electrónicav2/${category}/${subcategory}/article/storeId/${id}/c`}>
                              <strong>Ver más Detalles</strong>
                            </Link>
                          </p>
                          <ul className="ps-list--dot">
                            {Productos?.Promotions &&
                              Productos?.Promotions.map((item) => (
                                <li key={item.color}>{item.description}</li>
                              ))}
                          </ul>
                        </>
                      ) : (
                        <Skeleton height={"12rem"} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {viewButton && (
            <div className="modal-footer">
              {!isLoading ? (
                width > 766 ? (
                  <div className="ps-product__shopping">
                    <button
                      className="ps-btn text-white"
                      onClick={heanddleAddCart}>
                      Agregar al carrito
                    </button>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center p-2">
                    <button
                      className="ps-btn text-white w-100"
                      onClick={heanddleAddCart}>
                      Agregar al carrito
                    </button>
                  </div>
                )
              ) : (
                <Skeleton width={"250px"} height={"5rem"} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalViewData;
